import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=c2672c0c&scoped=true&"
import script from "./AddVendor.vue?vue&type=script&lang=js&"
export * from "./AddVendor.vue?vue&type=script&lang=js&"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=c2672c0c&lang=scss&scoped=true&"
import style1 from "./AddVendor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2672c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2672c0c')) {
      api.createRecord('c2672c0c', component.options)
    } else {
      api.reload('c2672c0c', component.options)
    }
    module.hot.accept("./AddVendor.vue?vue&type=template&id=c2672c0c&scoped=true&", function () {
      api.rerender('c2672c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/AddVendor.vue"
export default component.exports